export enum Roles {
    UNKNOWN = 'UNKNOWN',
    ADMIN = 'ADMIN',
    ANNOTATOR = 'ANNOTATOR',
    REVIEWER = 'REVIEWER',
}


export interface MenuItems {
    label: string;
    icon: string; // material icons
    path: string;
    roles: Roles[];
    children?: MenuItems[];
    expanded?: boolean;
}

export const allRoles: Roles[] = [Roles.ADMIN, Roles.ANNOTATOR, Roles.REVIEWER];


export const menuItems: MenuItems[] = [
      {
        label: 'dashboard',
        icon: 'dashboard',
        path: 'dashboard',
        roles: [ Roles.ADMIN],
    },
    // {
    //     label: 'Reports',
    //     icon: 'rss_feed',
    //     path: 'reports',
    //     roles: [Roles.ANNOTATOR, Roles.ADMIN],
    //     children: [
            {
                label: 'Report Summary',
                icon: 'insert_chart',
                path: 'reports/summary',
                roles: [Roles.ANNOTATOR,  Roles.REVIEWER],
            },
            // {
            //     label: 'Billing',
            //     icon: 'attach_money',
            //     path: 'billing',
            //     roles: [],
            // },
            // {
            //     label: 'Reports',
            //     icon: 'assessment',
            //     path: 'reports/current-reports',
            //     roles: [ Roles.ADMIN],
            // },
            {
                label: 'All Reports',
                icon: 'check_circle',
                path: 'reports/all-reports',
                roles: [Roles.ANNOTATOR, Roles.ADMIN, Roles.REVIEWER],
            },
        // ]
    // },
    {
        label: 'Configuration',
        icon: 'settings',
        path: 'configuration',
        roles: [Roles.ADMIN],
        children: [
            {
                label: 'System Users',
                icon: 'supervisor_account',
                path: 'system-users',
                roles: [Roles.ADMIN],
            },
            {
                label: 'Case Assignment',
                icon: 'assignment_ind',
                path: 'case-assignment',
                roles: [Roles.ADMIN],
            },
            {
                label: 'Reports Queue',
                icon: 'queue',
                path: 'reports-queue',
                roles: [Roles.ADMIN],
            },
            {
                label: 'Accuracy Check',
                icon: 'check_circle',
                path: 'accuracy-calculator',
                roles: [Roles.ADMIN],
            },
            {
                label: 'FTP Report Issue',
                icon: 'bug_report',
                path: 'ftp-report-issue',
                roles: [Roles.ADMIN],
            },
            {
                label: 'Test Master Data',
                icon: 'science',
                path: 'test-master-data',
                roles: [Roles.ADMIN],
            },
            {
                label: 'Settings',
                icon: 'tune',
                path: 'settings',
                roles: [Roles.ADMIN],
            },
            {
                label: 'License',
                icon: 'verified_user',
                path: 'license',
                roles: [Roles.ADMIN],
            }
        ]
    },
    // {
    //     label: 'Operations',
    //     icon: 'build',
    //     path: 'operations',
    //     roles: [],
    //     children: [
    //         {
    //             label: 'Drop Case',
    //             icon: 'remove_circle_outline',
    //             path: 'drop-case',
    //             roles: [Roles.ADMIN],
    //         },
    //         {
    //             label: 'Reassign',
    //             icon: 'autorenew',
    //             path: 'reassign',
    //             roles: [Roles.ADMIN],
    //         },
    //         {
    //             label: 'Manual Assignment',
    //             icon: 'assignment_ind',
    //             path: 'manual-assignment',
    //             roles: [Roles.ADMIN],
    //         },
    //         {
    //             label: 'Partner Status Count',
    //             icon: 'assignment',
    //             path: 'partner-status-count',
    //             roles: [Roles.ADMIN],
    //         }
    //     ]
    // }
   


]